import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const chatMarkdownDefaultVariants = {}
const chatMarkdownCompoundVariants = []

const chatMarkdownSlotNames = [
  [
    "root",
    "chatMarkdown__root"
  ]
]
const chatMarkdownSlotFns = /* @__PURE__ */ chatMarkdownSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, chatMarkdownDefaultVariants, getSlotCompoundVariant(chatMarkdownCompoundVariants, slotName))])

const chatMarkdownFn = memo((props = {}) => {
  return Object.fromEntries(chatMarkdownSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const chatMarkdownVariantKeys = []
const getVariantProps = (variants) => ({ ...chatMarkdownDefaultVariants, ...compact(variants) })

export const chatMarkdown = /* @__PURE__ */ Object.assign(chatMarkdownFn, {
  __recipe__: false,
  __name__: 'chatMarkdown',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: chatMarkdownVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, chatMarkdownVariantKeys)
  },
  getVariantProps
})